import LoadingPage from "components/LoadingPage";
import { lazy, Suspense } from "react";

const Sistemas = lazy(() => import("pages/Sistemas"));
const AgendarAqui = lazy(() => import("pages/Sistemas/AgendarAqui"));
const SecureFlex = lazy(() => import("pages/Sistemas/SecureFlex"));

const useRoutersSistemas = () => {
  return [
    {
      path: "/sistemas/",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <Sistemas />
        </Suspense>
      ),
    },
    {
      path: "/sistemas/sistema-agendar-aqui",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <AgendarAqui />
        </Suspense>
      ),
    },
    {
      path: "/sistemas/sistema-secure-flex",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <SecureFlex />
        </Suspense>
      ),
    },
  ];
};

export default useRoutersSistemas;
